module.exports = __webpack_public_path__ + "static/media/playstore.94c2f338.webp";